import { lazy } from 'react';
import type { FleetSectionDef } from './pages/FleetSectionPage';

// Pages and tabs load when first opened (NFR-04, docs §169).
const VehiclesTab = lazy(() => import('./components/VehiclesTab').then((m) => ({ default: m.VehiclesTab })));
const SupervisorsTab = lazy(() => import('./components/RegisterTabs').then((m) => ({ default: m.SupervisorsTab })));
const TransfersTab = lazy(() => import('./components/RegisterTabs').then((m) => ({ default: m.TransfersTab })));
const VerificationTab = lazy(() => import('./components/RegisterTabs').then((m) => ({ default: m.VerificationTab })));
const FleetPlanTab = lazy(() => import('./components/AcquisitionTabs').then((m) => ({ default: m.FleetPlanTab })));
const LeasesTab = lazy(() => import('./components/AcquisitionTabs').then((m) => ({ default: m.LeasesTab })));
const PurchaseRequestsTab = lazy(() => import('./components/AcquisitionTabs').then((m) => ({ default: m.PurchaseRequestsTab })));
const DriversTab = lazy(() => import('./components/DriversTab').then((m) => ({ default: m.DriversTab })));
const DispatchTab = lazy(() => import('./components/TripsTabs').then((m) => ({ default: m.DispatchTab })));
const TripRequestsTab = lazy(() => import('./components/TripsTabs').then((m) => ({ default: m.TripRequestsTab })));
const TripsTab = lazy(() => import('./components/TripsTabs').then((m) => ({ default: m.TripsTab })));
const ExceptionsTab = lazy(() => import('./components/ExceptionsTab').then((m) => ({ default: m.ExceptionsTab })));
const CardsTab = lazy(() => import('./components/FuelTabs').then((m) => ({ default: m.CardsTab })));
const ConsumptionTab = lazy(() => import('./components/FuelTabs').then((m) => ({ default: m.ConsumptionTab })));
const FillsTab = lazy(() => import('./components/FuelTabs').then((m) => ({ default: m.FillsTab })));
const StatementsTab = lazy(() => import('./components/FuelTabs').then((m) => ({ default: m.StatementsTab })));
const BoardTab = lazy(() => import('./components/WorkshopTabs').then((m) => ({ default: m.BoardTab })));
const JobCardsTab = lazy(() => import('./components/WorkshopTabs').then((m) => ({ default: m.JobCardsTab })));
const ServiceDueTab = lazy(() => import('./components/WorkshopTabs').then((m) => ({ default: m.ServiceDueTab })));
const ServicePlansTab = lazy(() => import('./components/WorkshopTabs').then((m) => ({ default: m.ServicePlansTab })));
const BaysAndRatesTab = lazy(() => import('./components/WorkshopSetupTabs').then((m) => ({ default: m.BaysAndRatesTab })));
const PartsCatalogueTab = lazy(() => import('./components/WorkshopSetupTabs').then((m) => ({ default: m.PartsCatalogueTab })));
const ProductivityTab = lazy(() => import('./components/WorkshopSetupTabs').then((m) => ({ default: m.ProductivityTab })));
const ComplianceTab = lazy(() => import('./components/RiskTabs').then((m) => ({ default: m.ComplianceTab })));
const DisposalTab = lazy(() => import('./components/RiskTabs').then((m) => ({ default: m.DisposalTab })));
const InsuranceTab = lazy(() => import('./components/RiskTabs').then((m) => ({ default: m.InsuranceTab })));
const AllowancesTab = lazy(() => import('./components/OperationsTabs').then((m) => ({ default: m.AllowancesTab })));
const AuthorisationsTab = lazy(() => import('./components/OperationsTabs').then((m) => ({ default: m.AuthorisationsTab })));
const AvailabilityTab = lazy(() => import('./components/OperationsTabs').then((m) => ({ default: m.AvailabilityTab })));
const CouponsTab = lazy(() => import('./components/OperationsTabs').then((m) => ({ default: m.CouponsTab })));
const MileageClaimsTab = lazy(() => import('./components/OperationsTabs').then((m) => ({ default: m.MileageClaimsTab })));
const RoutingRulesTab = lazy(() => import('./components/OperationsTabs').then((m) => ({ default: m.RoutingRulesTab })));
const TankDipsTab = lazy(() => import('./components/OperationsTabs').then((m) => ({ default: m.TankDipsTab })));
const TrainingTab = lazy(() => import('./components/OperationsTabs').then((m) => ({ default: m.TrainingTab })));
const CostPerVehicleTab = lazy(() => import('./components/CostsTabs').then((m) => ({ default: m.CostPerVehicleTab })));
const RechargeTab = lazy(() => import('./components/CostsTabs').then((m) => ({ default: m.RechargeTab })));
const TieOutTab = lazy(() => import('./components/CostsTabs').then((m) => ({ default: m.TieOutTab })));
const DefectsTab = lazy(() => import('./components/InspectionsTabs').then((m) => ({ default: m.DefectsTab })));
const HandoversTab = lazy(() => import('./components/InspectionsTabs').then((m) => ({ default: m.HandoversTab })));
const InspectionsTab = lazy(() => import('./components/InspectionsTabs').then((m) => ({ default: m.InspectionsTab })));
const AccidentsTab = lazy(() => import('./components/IncidentsTabs').then((m) => ({ default: m.AccidentsTab })));
const ComponentsTab = lazy(() => import('./components/IncidentsTabs').then((m) => ({ default: m.ComponentsTab })));
const FinesTab = lazy(() => import('./components/IncidentsTabs').then((m) => ({ default: m.FinesTab })));
const WarrantyTab = lazy(() => import('./components/IncidentsTabs').then((m) => ({ default: m.WarrantyTab })));
const MapTab = lazy(() => import('./components/UsageTabs').then((m) => ({ default: m.MapTab })));
const TelematicsTab = lazy(() => import('./components/UsageTabs').then((m) => ({ default: m.TelematicsTab })));
const UtilisationTab = lazy(() => import('./components/UsageTabs').then((m) => ({ default: m.UtilisationTab })));
const BookingsTab = lazy(() => import('./components/PlanningTabs').then((m) => ({ default: m.BookingsTab })));
const ReplacementTab = lazy(() => import('./components/PlanningTabs').then((m) => ({ default: m.ReplacementTab })));
const ScorecardsTab = lazy(() => import('./components/PlanningTabs').then((m) => ({ default: m.ScorecardsTab })));
const SettingsAccountsTab = lazy(() => import('./components/FleetSettingsTab').then((m) => ({ default: m.SettingsAccountsTab })));
const SettingsGeneralTab = lazy(() => import('./components/FleetSettingsTab').then((m) => ({ default: m.SettingsGeneralTab })));
const AlertRulesTab = lazy(() => import('./components/ConnectedTabs').then((m) => ({ default: m.AlertRulesTab })));
const ChecklistsTab = lazy(() => import('./components/ConnectedTabs').then((m) => ({ default: m.ChecklistsTab })));
const CustomFieldsTab = lazy(() => import('./components/ConnectedTabs').then((m) => ({ default: m.CustomFieldsTab })));
const GeofencesTab = lazy(() => import('./components/ConnectedTabs').then((m) => ({ default: m.GeofencesTab })));
const LivePositionsTab = lazy(() => import('./components/ConnectedTabs').then((m) => ({ default: m.LivePositionsTab })));
const AllocationTab = lazy(() => import('./components/FinanceTabs').then((m) => ({ default: m.AllocationTab })));
const BehaviourTab = lazy(() => import('./components/FinanceTabs').then((m) => ({ default: m.BehaviourTab })));
const BudgetsTab = lazy(() => import('./components/FinanceTabs').then((m) => ({ default: m.BudgetsTab })));
const IntegrationTab = lazy(() => import('./components/FinanceTabs').then((m) => ({ default: m.IntegrationTab })));
const KpisTab = lazy(() => import('./components/FinanceTabs').then((m) => ({ default: m.KpisTab })));
const MigrationTab = lazy(() => import('./components/FinanceTabs').then((m) => ({ default: m.MigrationTab })));
const ReconcileTab = lazy(() => import('./components/FinanceTabs').then((m) => ({ default: m.ReconcileTab })));
const TcoTab = lazy(() => import('./components/FinanceTabs').then((m) => ({ default: m.TcoTab })));
const TripLogTab = lazy(() => import('./components/FinanceTabs').then((m) => ({ default: m.TripLogTab })));

/**
 * The fleet module's sections, one per menu item, each with its leaves. The URL's last segment
 * names the leaf, so every tab is a real address; the rights are read once by the page.
 */
export const fleetSections = {
  vehicles: {
    area: 'Fleet', title: 'Vehicles', basePath: '/fleet/vehicles',
    description: 'The register: each vehicle linked to its fixed asset and cost centre, and the documents that keep it on the road.',
    views: [
      { key: 'register', label: 'Register' },
      { key: 'attention', label: 'Needs attention' },
      { key: 'transfers', label: 'Transfers' },
      { key: 'verification', label: 'Verification' },
    ],
    render: (view, ctx) => (view === 'attention' ? <VehiclesTab ctx={ctx} attention /> : view === 'transfers' ? <TransfersTab ctx={ctx} />
      : view === 'verification' ? <VerificationTab ctx={ctx} /> : <VehiclesTab ctx={ctx} />),
  } satisfies FleetSectionDef<'register' | 'attention' | 'transfers' | 'verification'>,

  acquisition: {
    area: 'Fleet', title: 'Acquisition', basePath: '/fleet/acquisition',
    description: 'Vehicles requested and approved, ordered through procurement, received from the order and capitalised into service (FR-ACQ); leased and hired vehicles; the fleet plan.',
    views: [
      { key: 'requests', label: 'Requests' },
      { key: 'plan', label: 'Fleet plan' },
      { key: 'leases', label: 'Leases and hire' },
    ],
    render: (view, ctx) => (view === 'plan' ? <FleetPlanTab ctx={ctx} /> : view === 'leases' ? <LeasesTab ctx={ctx} /> : <PurchaseRequestsTab ctx={ctx} />),
  } satisfies FleetSectionDef<'requests' | 'plan' | 'leases'>,

  drivers: {
    area: 'Fleet', title: 'Drivers', basePath: '/fleet/drivers',
    description: 'The driver register: linked to the employee where HR is on, with the licence, medical and the vehicle classes each may drive.',
    views: [
      { key: 'register', label: 'Register' },
      { key: 'training', label: 'Training' },
      { key: 'authorisations', label: 'Staff authorisations' },
      { key: 'allowances', label: 'Allowances' },
      { key: 'behaviour', label: 'Behaviour and fines' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'behaviour': return <BehaviourTab />;
        case 'training': return <TrainingTab ctx={ctx} />;
        case 'authorisations': return <AuthorisationsTab ctx={ctx} />;
        case 'allowances': return <AllowancesTab ctx={ctx} />;
        default: return <DriversTab ctx={ctx} />;
      }
    },
  } satisfies FleetSectionDef<'register' | 'training' | 'authorisations' | 'allowances' | 'behaviour'>,

  trips: {
    area: 'Fleet', title: 'Trips', basePath: '/fleet/trips',
    description: 'Trip requests approved by the budget holder, dispatched with a vehicle and driver that pass every check, and returned with the odometer.',
    views: [
      { key: 'mine', label: 'My requests' },
      { key: 'all', label: 'All requests' },
      { key: 'dispatch', label: 'To dispatch' },
      { key: 'out', label: 'Out now' },
      { key: 'returned', label: 'Returned' },
      { key: 'availability', label: 'Driver availability' },
      { key: 'mileage', label: 'Mileage claims' },
      { key: 'log', label: 'Trip log' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'log': return <TripLogTab />;
        case 'availability': return <AvailabilityTab />;
        case 'mileage': return <MileageClaimsTab ctx={ctx} />;
        case 'all': return <TripRequestsTab ctx={ctx} scope="All" />;
        case 'dispatch': return <DispatchTab ctx={ctx} />;
        case 'out': return <TripsTab ctx={ctx} status="Dispatched" />;
        case 'returned': return <TripsTab ctx={ctx} status="Returned" />;
        default: return <TripRequestsTab ctx={ctx} scope="Mine" />;
      }
    },
  } satisfies FleetSectionDef<'mine' | 'all' | 'dispatch' | 'out' | 'returned' | 'availability' | 'mileage' | 'log'>,

  fuel: {
    area: 'Fleet', title: 'Fuel', basePath: '/fleet/fuel',
    description: 'Every fill with its odometer, the card statements matched to them, consumption against what each vehicle should do and fuel by cost centre against the ledger.',
    views: [
      { key: 'fills', label: 'Fills' },
      { key: 'cards', label: 'Cards' },
      { key: 'statements', label: 'Statements' },
      { key: 'consumption', label: 'Consumption' },
      { key: 'coupons', label: 'Coupons' },
      { key: 'dips', label: 'Tank dips and posting' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'coupons': return <CouponsTab ctx={ctx} />;
        case 'dips': return <TankDipsTab ctx={ctx} />;
        case 'cards': return <CardsTab ctx={ctx} />;
        case 'statements': return <StatementsTab ctx={ctx} />;
        case 'consumption': return <ConsumptionTab />;
        default: return <FillsTab ctx={ctx} />;
      }
    },
  } satisfies FleetSectionDef<'fills' | 'cards' | 'statements' | 'consumption' | 'coupons' | 'dips'>,

  workshop: {
    area: 'Fleet', title: 'Workshop', basePath: '/fleet/workshop',
    description: 'Services due by km or months, job cards with their parts, labour and downtime on the board, and outside repairs bought through the purchase ledger.',
    views: [
      { key: 'board', label: 'Board' },
      { key: 'due', label: 'Services due' },
      { key: 'cards', label: 'Open cards' },
      { key: 'closed', label: 'Closed' },
      { key: 'plans', label: 'Service plans' },
      { key: 'catalogue', label: 'Parts catalogue' },
      { key: 'bays', label: 'Bays and rates' },
      { key: 'productivity', label: 'Productivity' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'catalogue': return <PartsCatalogueTab ctx={ctx} />;
        case 'bays': return <BaysAndRatesTab ctx={ctx} />;
        case 'productivity': return <ProductivityTab />;
        case 'due': return <ServiceDueTab ctx={ctx} />;
        case 'cards': return <JobCardsTab />;
        case 'closed': return <JobCardsTab closed />;
        case 'plans': return <ServicePlansTab ctx={ctx} />;
        default: return <BoardTab ctx={ctx} />;
      }
    },
  } satisfies FleetSectionDef<'board' | 'due' | 'cards' | 'closed' | 'plans' | 'catalogue' | 'bays' | 'productivity'>,

  costs: {
    area: 'Fleet', title: 'Fleet Costs', basePath: '/fleet/costs',
    description: 'What each vehicle costs and its cost per km, the fleet\'s accounts against the ledger, and pool vehicles recharged to the cost centres that used them.',
    views: [
      { key: 'vehicles', label: 'Cost per vehicle' },
      { key: 'tieout', label: 'Against the ledger' },
      { key: 'recharge', label: 'Recharge' },
      { key: 'tco', label: 'Cost of ownership' },
      { key: 'budgets', label: 'Budgets' },
      { key: 'allocation', label: 'Overhead allocation' },
      { key: 'reconcile', label: 'Reconciliations' },
      { key: 'kpis', label: 'KPIs' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'tieout': return <TieOutTab ctx={ctx} />;
        case 'recharge': return <RechargeTab ctx={ctx} />;
        case 'tco': return <TcoTab />;
        case 'budgets': return <BudgetsTab ctx={ctx} />;
        case 'allocation': return <AllocationTab ctx={ctx} />;
        case 'reconcile': return <ReconcileTab />;
        case 'kpis': return <KpisTab />;
        default: return <CostPerVehicleTab />;
      }
    },
  } satisfies FleetSectionDef<'vehicles' | 'tieout' | 'recharge' | 'tco' | 'budgets' | 'allocation' | 'reconcile' | 'kpis'>,

  inspections: {
    area: 'Fleet', title: 'Inspections', basePath: '/fleet/inspections',
    description: 'Checks done on the vehicles (most by drivers in the driver app), the defects they found, and vehicles handed between drivers with both PINs.',
    views: [
      { key: 'defects', label: 'Defects' },
      { key: 'all', label: 'Inspections' },
      { key: 'handovers', label: 'Handovers' },
      { key: 'checklists', label: 'Checklists' },
    ],
    render: (view, ctx) => (view === 'all' ? <InspectionsTab /> : view === 'handovers' ? <HandoversTab /> : view === 'checklists' ? <ChecklistsTab ctx={ctx} /> : <DefectsTab ctx={ctx} />),
  } satisfies FleetSectionDef<'defects' | 'all' | 'handovers' | 'checklists'>,

  incidents: {
    area: 'Fleet', title: 'Incidents', basePath: '/fleet/incidents',
    description: 'Accidents and insurance claims, traffic fines charged back to drivers, tyres and batteries by serial, and warranty claims.',
    views: [
      { key: 'accidents', label: 'Incidents' },
      { key: 'fines', label: 'Fines' },
      { key: 'tyres', label: 'Tyres and batteries' },
      { key: 'warranty', label: 'Warranty claims' },
      { key: 'insurance', label: 'Insurance' },
      { key: 'compliance', label: 'Compliance calendar' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'insurance': return <InsuranceTab ctx={ctx} />;
        case 'compliance': return <ComplianceTab />;
        case 'fines': return <FinesTab ctx={ctx} />;
        case 'tyres': return <ComponentsTab ctx={ctx} />;
        case 'warranty': return <WarrantyTab ctx={ctx} />;
        default: return <AccidentsTab ctx={ctx} />;
      }
    },
  } satisfies FleetSectionDef<'accidents' | 'fines' | 'tyres' | 'warranty' | 'insurance' | 'compliance'>,

  usage: {
    area: 'Fleet', title: 'Fleet Use', basePath: '/fleet/usage',
    description: 'How much each vehicle is used and which stand idle, the journeys from the trackers checked against the trip log, and the map.',
    views: [
      { key: 'utilisation', label: 'Utilisation' },
      { key: 'idle', label: 'Idle vehicles' },
      { key: 'telematics', label: 'Trackers' },
      { key: 'map', label: 'Map' },
      { key: 'live', label: 'Live positions' },
      { key: 'geofences', label: 'Geofences' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'idle': return <UtilisationTab idleOnly />;
        case 'telematics': return <TelematicsTab ctx={ctx} />;
        case 'map': return <MapTab allowed={ctx.canViewLocations} />;
        case 'live': return <LivePositionsTab ctx={ctx} />;
        case 'geofences': return <GeofencesTab ctx={ctx} />;
        default: return <UtilisationTab />;
      }
    },
  } satisfies FleetSectionDef<'utilisation' | 'idle' | 'telematics' | 'map' | 'live' | 'geofences'>,

  planning: {
    area: 'Fleet', title: 'Bookings and Planning', basePath: '/fleet/planning',
    description: 'Pool vehicles booked ahead and turned into trip requests, each driver’s monthly scorecard, and when each vehicle falls due for replacement and disposal.',
    views: [
      { key: 'bookings', label: 'Pool bookings' },
      { key: 'scorecards', label: 'Driver scorecards' },
      { key: 'replacement', label: 'Replacement plan' },
      { key: 'disposal', label: 'Disposals' },
    ],
    render: (view, ctx) => (view === 'scorecards' ? <ScorecardsTab ctx={ctx} /> : view === 'replacement' ? <ReplacementTab ctx={ctx} /> : view === 'disposal' ? <DisposalTab ctx={ctx} />
      : <BookingsTab ctx={ctx} />),
  } satisfies FleetSectionDef<'bookings' | 'scorecards' | 'replacement' | 'disposal'>,

  exceptions: {
    area: 'Fleet', title: 'Exceptions', basePath: '/fleet/exceptions',
    description: 'What the fleet checks flagged — expired documents now, and later consumption, card statements, odometer and GPS — for someone to resolve.',
    views: [
      { key: 'open', label: 'Open' },
      { key: 'resolved', label: 'Resolved' },
      { key: 'dismissed', label: 'Dismissed' },
    ],
    render: (view, ctx) => <ExceptionsTab ctx={ctx} status={view === 'resolved' ? 'Resolved' : view === 'dismissed' ? 'Dismissed' : 'Open'} />,
  } satisfies FleetSectionDef<'open' | 'resolved' | 'dismissed'>,

  settings: {
    area: 'Fleet', title: 'Fleet Settings', basePath: '/fleet/settings',
    views: [
      { key: 'general', label: 'General' },
      { key: 'accounts', label: 'Accounts' },
      { key: 'supervisors', label: 'Supervisors and sites' },
      { key: 'routing', label: 'Trip routing' },
      { key: 'alerts', label: 'Alert rules' },
      { key: 'fields', label: 'Custom fields' },
      { key: 'integration', label: 'Integration monitor' },
      { key: 'migration', label: 'Migration' },
    ],
    render: (view, ctx) => (view === 'accounts' ? <SettingsAccountsTab /> : view === 'supervisors' ? <SupervisorsTab /> : view === 'routing' ? <RoutingRulesTab ctx={ctx} />
      : view === 'alerts' ? <AlertRulesTab ctx={ctx} /> : view === 'fields' ? <CustomFieldsTab ctx={ctx} /> : view === 'integration' ? <IntegrationTab ctx={ctx} />
      : view === 'migration' ? <MigrationTab ctx={ctx} /> : <SettingsGeneralTab ctx={ctx} />),
  } satisfies FleetSectionDef<'general' | 'accounts' | 'supervisors' | 'routing' | 'alerts' | 'fields' | 'integration' | 'migration'>,
};
